import { Outlet } from 'react-router-dom';
import TouchNav from './TouchNav';
import { AppShellFrame, AppShellMainContent } from './styled';

function AppShell() {
  return (
    <AppShellFrame>
      <TouchNav />

      <AppShellMainContent>
        <Outlet />
      </AppShellMainContent>
    </AppShellFrame>
  );
}

export default AppShell;
